import React from "react";
import "../../../assets/css/container/main/AboutFactWeb.css";

export default function TermsPolicy() {
	return (
		<div className="about-container">
			<h1 className="about-title">이용약관</h1>

			<section className="about-section">
				<h2>약관의 목적</h2>
				<p>
					본 이용약관은 FactWeb이 제공하는 팩트 검증 및 정보 공유 서비스의
					이용과 관련하여 서비스와 이용자 간의 권리와 의무,
					책임 사항을 명확히 하기 위해 마련되었습니다.
				</p>
			</section>

			<section className="about-section">
				<h2>서비스의 성격</h2>
				<p>
					FactWeb은 특정 정치·이념을 대변하지 않으며,
					이용자가 제시한 주장과 근거를 바탕으로
					팩트 중심의 검증과 토론이 이루어지는 플랫폼입니다.
					모든 검증 결과는 참고 정보로 제공됩니다.
				</p>
			</section>

			<section className="about-section">
				<h2>이용자의 책임</h2>
				<p>
					서비스에 게시되는 모든 콘텐츠의 책임은 작성자에게 있으며,
					허위 사실 유포, 명예훼손, 조작 및 선동 행위는 제한될 수 있습니다.
					FactWeb은 건전한 토론 환경 유지를 위해 운영 개입을 할 수 있습니다.
				</p>
			</section>

			<section className="about-section">
				<h2>약관 변경</h2>
				<p>
					본 약관은 서비스 운영상 필요에 따라 변경될 수 있으며,
					변경 사항은 서비스 내 공지를 통해 안내됩니다.
				</p>
			</section>
		</div>
	);
}
